<template>
    <div class="estates-list">
        <modal
            v-if="$root.is_mobile"
            name="listing-map"
            ref="listing-map"
            extra-class="full-screen-modal listing-map-modal"
        >
            <template slot="body">
                <div class="tecnomap-container">
                    <tecno-map
                        ref="map"
                        class="tecnomap-listing"
                        :options="options"
                        :section="section"
                        @ready="loadEstates">
                    </tecno-map>

                    <div v-if="estatesCarousel.length > 0" class="tecnomap-estates">
                        <my-carousel :per-page-custom="[[0, 1], [768, 2], [991, 2], [1100, 3], [1200, 4]]">
                            <template v-for="estate in estatesCarousel">
                                <slide :key="estate.id">
                                    <div
                                        :data-id="estate.id"
                                        v-waypoint="{ active: true, callback: visibilityChanged, options: {} }"
                                        class="tecnomap-estate-card"
                                    >
                                        <estate-card :estate="estate" />
                                    </div>
                                </slide>
                            </template>
                        </my-carousel>
                    </div>
                </div>
            </template>
        </modal>

        <template v-if="showList || !$root.is_mobile">
            <slot v-if="pageSSR" name="estates" />

            <template v-else-if="pageLoading" v-for="key in 15" >
                <estate-card-skeleton :key="key"></estate-card-skeleton>
            </template>

            <!-- <template v-else-if="pageEstates.length == 0">
                <h5>{{ lang.heading.no_estates_found }}</h5>
                <button
                    type="button"
                    class="btn btn-network save-search-button"
                    @click.prevent="openSaveSearchModal"
                    v-if="section == 'estate'"
                >            
                    <masked-image :src="'/img/icons/notifications.svg'"></masked-image>            
                    {{ lang.labels.save_search }}
                </button>
            </template> -->

            <template v-else  v-for="(estate, index_estate) in pageEstates">
                <estate-card
                    :estate="estate"
                    :key="estate.id"
                    :highlight="true"
                    origin="index"
                >
                </estate-card>

                <agencies-advertising
                    v-if="config.agencies_advertising && (index_estate == 5 || (pageEstates.length < 5 && estate.id == pageEstates.at(-1).id))"
                    :search="searchFilters()"
                >
                </agencies-advertising>
            </template>
        </template>

        <div class="w-100 text-center mx-auto p-1" v-if="pagePagination['total_pages'] > 1">
            <ul class="pagination">
                <template v-if="pagePagination['current_page'] > 1">
                    <li><a :href="pagePagination['url'] + '?' + pagePagination['first_page_uri']" @click.prevent="loadPage(1)">&lt;&lt;</a></li>
                    <li><a :href="pagePagination['url'] + (pagePagination['pages_uri'][pagePagination['current_page'] - 1])" @click.prevent="loadPage(pagePagination['current_page'] - 1)">&lt;</a></li>
                </template>

                <li v-for="(page_uri, page) in pagePagination['pages_uri']" :key="page">
                    <a :href="pagePagination['url'] + page_uri" @click.prevent="loadPage(page)" :class="pagePagination['current_page'] == page ? ' active' : ''">{{ page }}</a>
                </li>

                <template v-if="pagePagination['current_page'] < pagePagination['total_pages']">
                    <li><a :href="pagePagination['url'] + pagePagination['pages_uri'][pagePagination['current_page'] + 1]" @click.prevent="loadPage(pagePagination['current_page'] + 1)">&gt;</a></li>
                    <li><a :href="pagePagination['url'] + pagePagination['last_page_uri']" @click.prevent="loadPage(pagePagination['total_pages'])">&gt;&gt;</a></li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import VueWaypoint from 'vue-waypoint'

import EstateCardSkeleton from './CardSkeleton'
import Modal from '../Modal'
import TecnoMap from '../maps/Map'
import MyCarousel from '../MyCarousel'

export default {
    components: {
        'estate-card-skeleton': EstateCardSkeleton,
        'modal': Modal,
        'my-carousel': MyCarousel,
        'tecno-map': TecnoMap,
    },

    data() {
        return {
            loadMap: false,
            mapReady: false,
            showList: true,
            estatesCarousel: [],
            tracked: [],

            options: {
                minZoom: 10,
                maxZoom: 18,
                currentZoom: 15,
                style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                mapCenter: {},

                features: {
                    uriCoords: false,
                    scrollZoom: false,
                    dragRotate: false,
                    touchZoomRotate: true
                },

                modules: {
                    navigationControl: {
                        uiPosition: 'bottom-left',
                        zoom: true
                    },

                    drawer: {
                        modes: [],
                        insideColor: '#078c33',
                        outsideColor: '#00d054',
                        fillColor: '#089642',
                        textColor: '#fff'
                    }
                }
            },

            pageSSR: true,
            pageEstates: [],
            pagePagination: {},
            pageLoading: false,

            pageAdditionalSearch: {},
            cancel_token: null
        }
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        search: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            required: true,
        },

        map_center: {},
        pagination: {},
    },


    computed: {
        lang() {
            return this.$root.lang.estates_list;
        }
    },

    watch: {
        mapReady: function (status) {
            if(status)
                this.registerListeners()
            else
                this.unregisterListeners()
        },

        loadMap: function(status) {
            if(status)
            {
                window.events.$emit('showModal', { name: 'listing-map' })
                if(this.map_center == false)
                    this.options.mapCenter.coords = [0,0];
                else
                    this.options.mapCenter.coords = this.map_center;
            }
            else
            {
                this.mapReady = false;
                window.events.$emit('hideModal', { name: 'listing-map' })
            }
        }
    },

    methods: {
        registerListeners()
        {
            window.addEventListener('tecnomap.drawer.markerClusterClick', this.showEstateDetails);
            window.addEventListener('tecnomap.drawer.markerClick', this.showEstateDetails);
            window.addEventListener('tecnomap.click', this.mapClicked);
        },

        unregisterListeners()
        {
            window.removeEventListener('tecnomap.drawer.markerClusterClick', this.showEstateDetails);
            window.removeEventListener('tecnomap.drawer.markerClick', this.showEstateDetails);
            window.removeEventListener('tecnomap.click', this.mapClicked);
        },

        searchFilters() {
            return {
                ...this.search,
                ...this.pageAdditionalSearch,
                section: this.section
            };
        },

        loadEstates() {
            axios.get('/api/estates/search-map-list', {
                params: this.searchFilters()
            })
            .then((response) => {
                window.events.$emit('list.fallback', response.data.fallback)
                window.events.$emit('list.heading.count', response.data.collection.features.length + response.data.hidden)
                window.events.$emit('list.heading.hidden_count', response.data.hidden)
                window.dispatchEvent(new CustomEvent('tecnomap.drawer.setMarkers', { detail: { id: this.$refs.map.id, featureCollection: response.data.collection, bounds: true }}))
                this.mapReady = true;
            })
            .catch((error) => {
                // console.log(error)
            })

            let polygons_body = {
                id: this.searchFilters()['polygon_id'],
                province: this.searchFilters()['province'],
                city: this.searchFilters()['city'],
                region: this.searchFilters()['region'],
            }

            if(this.searchFilters()['districts'] != undefined || this.searchFilters()['district'] != undefined)
            {
                polygons_body['districts'] = this.searchFilters()['districts'] == undefined ? [ this.searchFilters()['district'] ] : this.searchFilters()['districts'].split('|')
            }

            if(this.searchFilters()['cardinal'] != undefined)
            {
                polygons_body['cardinal'] = this.searchFilters()['cardinal']
            }

            axios.get('/api/estates/get-polygons', {
                params: polygons_body
            })
            .then((response) => {
                window.dispatchEvent(new CustomEvent('tecnomap.drawer.setPolygons', { detail: { 
                    id: this.$refs.map.id, 
                    featureCollection: response.data, 
                    editable: false, 
                    bounds: this.searchFilters()['view'] == undefined ? true : false  
                }}));
                
                window.events.$emit('bottommenu.map.polygons', response.data);
            })
            .catch((error) => {
                if((typeof error !== 'undefined') && (error.status == 404))
                {
                    // flash(this.lang.flash.expired, 'error')
                    // window.events.$emit('Drawer.invoke', { mode: 'hand', expired: true })
                }
                else
                {
                    flash(this.lang.flash.error, 'error')
                }
            })
        },

        showEstateDetails(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - showEstateDetails', event);

                // window.isLoading()
                axios.get('/api/estates/search-by-ids', {
                    params: {
                        ids: event.detail.features.map((feature) => feature.id),
                        section: this.section
                    }
                })
                .then((response) => {
                    this.estatesCarousel = response.data
                })
                .catch((error) => {
                    // console.log(error)
                })
                .then(() => {
                    window.stopLoading()
                })
            }
        },

        mapClicked(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - mapClicked', event);
                this.estatesCarousel = [];
            }
        },

        loadPage(page) {
            // console.log('loadPage', this.searchFilters(), this.pageAdditionalSearch)
            // window.isLoading()
            this.pageSSR = false
            this.pageLoading = true

            if(this.cancel_token != null)
                this.cancel_token.cancel();
            this.cancel_token = axios.CancelToken.source()

            window.scrollTo(0,0)

            axios.get('/api/estates/search', {
                cancelToken: this.cancel_token.token,
                params: {
                    ...this.searchFilters(),
                    page: page,
                    section: this.section
                }
            })
            .then((response) => {
                if(response != undefined)
                {
                    this.pageEstates = response.data.estates
                    this.pagePagination = {
                        ...this.pagePagination,
                        ...response.data.pagination
                    }
                    
                    this.pageLoading = false
                    window.history.pushState({path:response.data.current_url},'',response.data.current_url)

                    window.events.$emit('list.title', response.data.title)
                    window.events.$emit('list.districts_list', response.data.districts_list)
                    window.events.$emit('list.quarters_list', response.data.quarters_list)
                    window.events.$emit('list.cities', response.data.cities)
                    window.events.$emit('list.quarters', response.data.quarters)
                    window.events.$emit('list.districts', response.data.districts)
                    window.events.$emit('list.placeholder', response.data.placeholder)
                    window.events.$emit('list.filter_list', response.data.filter_list)
                    window.events.$emit('list.cities_list', response.data.cities_list)
                    window.events.$emit('list.breadcrumb', response.data.breadcrumb)
                    window.events.$emit('list.fallback', response.data.fallback)
                    window.events.$emit('list.geo', response.data.geo)
                    window.events.$emit('list.type', response.data.type)
                    window.events.$emit('list.contract', response.data.contract)
                    window.events.$emit('list.heading.count', response.data.pagination.total_items)
                    window.events.$emit('list.heading.count_list', response.data.pagination.total_items)
                    // window.events.$emit('list.heading.hidden_count', 0)
                }
            })
            .catch((error) => {
                // console.log(error)
                this.pageLoading = false
            }).then(() => {
                window.stopLoading()
            })
        },

        visibilityChanged({ el, going, direction }) {
            // console.log(this.tracked.push(el.dataset.id))
            if (going === this.$waypointMap.GOING_IN) {
                this.tracked.push(el.dataset.id)
            }
        }
    },

    created() {
        if(this.$root.network == 'tecnorete')
        {
            this.options.modules.drawer = {
                ...this.options.modules.drawer,
                insideColor: '#003596',
                outsideColor: '#53BAFF',
                fillColor: '#003596',
                textColor: '#ffffff',
            }
        }
    },

    mounted() {
        this.pagePagination = this.pagination;
        window.events.$on('toggleListingView', event => {
            // console.log('toggleListingView', event);
            this.loadMap = event.map;
            this.showList = event.list;
        })

        window.events.$on('list.update.bounds', event => {
            if(window.map_listing_refresh)
            {
                this.pageAdditionalSearch.view = event
                this.loadPage(this.search.page)
            }
        })

        window.events.$on('list.update.polygon_id', event => {
            if(window.map_listing_refresh)
            {
                this.pageAdditionalSearch.polygon_id = event
                this.loadPage(this.search.page)
            }
        })

        window.events.$on('list.update.filters', event => {
            // console.log('List - list.update.filters', event)
            this.pageAdditionalSearch = {
                ...this.pageAdditionalSearch,
                ...event
            }
            this.loadPage(this.search.page)
        })
    },

    beforeDestroy() {
        // console.log('Portale/Maps/Drawer - beforeDestroy');
        this.unregisterListeners()
    },
}
</script>

<style lang="sass">
    .listing-map-modal
        margin-top: 9.6vh
        height: calc(100vh - 19.6vh)
        z-index: 1 !important

        .modal-backdrop
            display: none
        
        .modal-dialog 

            .modal-header
                display: none

            .modal-footer
                display: none

            .modal-content
                height: calc(100vh - 16.6vh)

                .modal-body
                    padding: 0

        .tecnomap-container
            .tecnomap-listing
                .mapboxgl-map
                    width: 100%
                    height: calc(100vh - 16.6vh)
                    display: block
                    background: #fff
</style>